// apps/web/src/widgets/use-other-widget-state.ts
//
// Phase 6 — D-09 escape-hatch hook for cross-widget state reads.
// Throws if used outside <RecipeStateProvider>. Phase 9's constraint engine
// reuses the same context shape.
import { useContext } from "react";
import { RecipeStateContext } from "./recipe-state-provider.js";
import type { WidgetInstanceId, WidgetState } from "./widget-renderer-props.js";

export function useOtherWidgetState(widgetId: WidgetInstanceId): WidgetState | undefined {
  const ctx = useContext(RecipeStateContext);
  if (ctx === null) {
    throw new Error(
      "useOtherWidgetState must be called inside <RecipeStateProvider>. " +
        "Wrap your widget tree in the provider at the spread level.",
    );
  }
  return ctx.states.get(widgetId);
}
